// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1CNnN","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3FHKA"};